import { ReactElement } from 'react';
import styled from 'styled-components';
import { paletteHelper, spacingHelper } from '@rea-group/construct-kit-core';

type BurgerButtonProps = {
  handleButtonClick: () => void;
  isMenuOpen: boolean;
};

interface BurgerLineProps {
  $isMenuOpen: boolean;
}

const BurgerIconButton = styled.button`
  width: ${spacingHelper('large')};
  height: ${spacingHelper('large')};
  margin-right: ${spacingHelper('extraSmall')};
  position: relative;
  transition: all 0.5s ease-in-out 0s;
  transform: rotate(0deg);
  flex-shrink: 0;

  ${({ theme }) => theme.layoutBreakpoints.medium} {
    margin-right: ${spacingHelper('medium')};
  }

  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    display: none;
  }
`;

const BurgerLine = styled.span<BurgerLineProps>`
  display: block;
  position: absolute;
  height: 0.0625rem;
  width: 1.375rem;
  left: 0.0625rem;
  background: ${paletteHelper('backgroundPrimaryInverted')};
  opacity: 1;
  transition: all 0.25s ease-in-out 0s;
  will-change: transform;

  &:nth-child(1) {
    top: ${(props) => (props.$isMenuOpen ? '0.75rem' : '0.3125rem')};
    transform-origin: center;
    transform: ${(props) =>
      props.$isMenuOpen
        ? 'rotate(45deg) translate3d(0, 0, 0);'
        : 'rotate(0deg) translate3d(0, 0, 0);'};
  }

  &:nth-child(2) {
    top: ${spacingHelper('small')};
    transform-origin: center;
    opacity: ${(props) => (props.$isMenuOpen ? '0' : '1')};
    transform: ${(props) =>
      props.$isMenuOpen
        ? 'rotate(0deg) translate3d(0, 0, 0);'
        : 'rotate(0deg) translate3d(0, 0, 0);'};
  }

  &:nth-child(3) {
    top: ${(props) => (props.$isMenuOpen ? '0.75rem' : '1.1875rem')};
    transform-origin: center;
    transform: ${(props) =>
      props.$isMenuOpen
        ? 'rotate(-45deg) translate3d(0, 0, 0);'
        : 'rotate(0deg) translate3d(0, 0, 0);'};
  }
`;

const BurgerButton = ({
  handleButtonClick,
  isMenuOpen,
}: BurgerButtonProps): ReactElement => {
  return (
    <BurgerIconButton
      aria-label="Main site navigation"
      className="burgerIconContainer"
      onClick={() => handleButtonClick()}
      aria-expanded={isMenuOpen}
    >
      <BurgerLine $isMenuOpen={isMenuOpen}></BurgerLine>
      <BurgerLine $isMenuOpen={isMenuOpen}></BurgerLine>
      <BurgerLine $isMenuOpen={isMenuOpen}></BurgerLine>
    </BurgerIconButton>
  );
};

export default BurgerButton;
